import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Contact.css";
import { Mail, MapPin, Phone } from "lucide-react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill all fields!");
      return;
    }

    const response = await fetch("https://auxititpt.org/Backend/contact_api.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (result.status === "success") {
      setStatus("Message sent successfully!");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } else {
      setStatus("Failed to send message");
    }
  };

  return (
    <section className="contact-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="text-primary fw-bold">Get in Touch</h2>
          <p className="text-secondary">
            Feel free to reach out to us for any inquiries or assistance.
          </p>
        </div>

        <div className="row g-4">
          {/* Form */}
          <div className="col-lg-8 col-md-7">
            <form onSubmit={handleSubmit} className="contact-form p-4 shadow-sm bg-white rounded">
              
              {status && <div className="alert alert-info">{status}</div>}

              <div className="mb-3">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <textarea
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary w-100 fw-semibold">
                Submit
              </button>
            </form>
          </div>

          {/* Info Section */}
          <div className="col-lg-4 col-md-5">
            <div className="info-box p-4 mb-3 bg-white shadow-sm rounded d-flex align-items-start">
              <MapPin color="#00294f" className="me-3 fs-3" />
              <div>
                <h6 className="fw-bold text-dark mb-1">Address</h6>
                <p className="mb-0 text-muted">
                  21-A, Gandhi Road, Railway Station Road,<br/> Tirupattur - 635601
                </p>
              </div>
            </div>

            <div className="info-box p-4 mb-3 bg-white shadow-sm rounded d-flex align-items-start">
              <Mail color="#00294f" className="me-3 fs-3" />
              <div>
                <h6 className="fw-bold text-dark mb-1">Mail Us</h6>
                <p className="mb-0 text-muted">auxiliumttc1973@gmail.com</p>
              </div>
            </div>

            <div className="info-box p-4 bg-white shadow-sm rounded d-flex align-items-start">
              <Phone color="#00294f" className="me-3 fs-3" />
              <div>
                <h6 className="fw-bold text-dark mb-1">Telephone</h6>
                <p className="mb-0 text-muted">(+91) 9385201431, 9487271432</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;
